
import React from 'react';


export default function() {
  return (
    <svg version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="15" height="20"
      viewBox="0 0 15 20"
      className="sbm-svg"
    >
      <path d="M10 0V5H15L10 0ZM8.75 5V0H1.875C0.839453 0 0 0.839453 0 1.875V18.125C0 19.1602 0.839453 20 1.875 20H13.125C14.1605 20 15 19.1605 15 18.125V6.25H10.0352C9.30859 6.25 8.75 5.69141 8.75 5ZM10.625 16.25H4.375C4.03125 16.25 3.75 15.9688 3.75 15.625C3.75 15.2812 4.03125 15 4.375 15H10.625C10.9702 15 11.25 15.2798 11.25 15.625C11.25 15.9688 10.9688 16.25 10.625 16.25ZM10.625 13.75H4.375C4.03125 13.75 3.75 13.4688 3.75 13.125C3.75 12.7812 4.03125 12.5 4.375 12.5H10.625C10.9702 12.5 11.25 12.7798 11.25 13.125C11.25 13.4688 10.9688 13.75 10.625 13.75ZM11.25 10.625C11.25 10.9688 10.9688 11.25 10.625 11.25H4.375C4.03125 11.25 3.75 10.9688 3.75 10.625C3.75 10.2812 4.03125 10 4.375 10H10.625C10.9688 10 11.25 10.2812 11.25 10.625Z" />
    </svg>
  );
};

